<script setup lang="ts">
/**
 * Persistent product footer (PRD §6.1 PE-1.4, closes rl-a80).
 *
 * Mounted on both layouts, so Privacy and Terms are reachable from every
 * page, including by a signed-in student — the person most likely to want
 * them.
 * "Analytics settings" reopens the analytics banner (rl-lif9), so the
 * answer can be changed from any page.
 */
import { useConsentStore } from "@/stores/consent";

const consent = useConsentStore();
const year = new Date().getFullYear();
</script>

<template>
  <footer class="app-footer">
    <span class="footer-copy">&copy; {{ year }} RevisionLab</span>
    <nav class="footer-links" aria-label="Legal and support">
      <RouterLink to="/privacy">Privacy</RouterLink>
      <RouterLink to="/terms">Terms</RouterLink>
      <a href="mailto:support@revisionlab.ai">support@revisionlab.ai</a>
      <button
        type="button"
        class="footer-settings"
        data-testid="analytics-settings"
        @click="consent.openAnalyticsChoice()"
      >
        Analytics settings
      </button>
    </nav>
  </footer>
</template>

<style scoped>
.app-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
  padding: var(--sp-5) 0 var(--sp-2);
  margin-top: var(--sp-8);
  border-top: 1px solid var(--rl-border-subtle);
  font-family: var(--rl-font-sans);
  font-size: var(--rl-text-sm);
  color: var(--rl-fg-3);
}

.footer-copy {
  letter-spacing: -0.005em;
}

/* Wraps rather than widening the page: unwrapped, the four links need ~356px
   and a 320px phone zooms every signed-in page out to fit them. */
.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-2) var(--sp-4);
}

.footer-links a,
.footer-settings {
  color: var(--rl-fg-3);
  text-decoration: none;
  transition: color var(--t-fast);
}

.footer-settings {
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  background: none;
}

.footer-links a:hover,
.footer-settings:hover {
  color: var(--rl-fg-1);
  text-decoration: underline;
}
</style>
